module.exports = __webpack_public_path__ + "static/media/bg.622bb7a1.jpeg";